var map = {
	".": 8948,
	"./": 8948,
	"./DailyMotion": 89258,
	"./DailyMotion.js": 89258,
	"./Facebook": 86867,
	"./Facebook.js": 86867,
	"./FilePlayer": 88054,
	"./FilePlayer.js": 88054,
	"./Kaltura": 39351,
	"./Kaltura.js": 39351,
	"./Mixcloud": 71500,
	"./Mixcloud.js": 71500,
	"./Mux": 23048,
	"./Mux.js": 23048,
	"./SoundCloud": 81095,
	"./SoundCloud.js": 81095,
	"./Streamable": 88717,
	"./Streamable.js": 88717,
	"./Twitch": 36354,
	"./Twitch.js": 36354,
	"./Vidyard": 50734,
	"./Vidyard.js": 50734,
	"./Vimeo": 45729,
	"./Vimeo.js": 45729,
	"./Wistia": 57311,
	"./Wistia.js": 57311,
	"./YouTube": 70830,
	"./YouTube.js": 70830,
	"./index": 8948,
	"./index.js": 8948,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players": 8948,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/": 8948,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion": 89258,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion.js": 89258,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook": 86867,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook.js": 86867,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer": 88054,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer.js": 88054,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura": 39351,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura.js": 39351,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud": 71500,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud.js": 71500,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux": 23048,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux.js": 23048,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud": 81095,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud.js": 81095,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable": 88717,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable.js": 88717,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch": 36354,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch.js": 36354,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard": 50734,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard.js": 50734,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo": 45729,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo.js": 45729,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia": 57311,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia.js": 57311,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube": 70830,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube.js": 70830,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index": 8948,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index.js": 8948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85456;